import { createContext } from 'react';

export const OverlayContext = createContext<object | null>(null);
